import * as z from "zod";

// Definición de tipos
export type Category = {
  id: number;
  name: string;
  slug: string;
  parentId: number | null;
  level: number;
  path: string;
  description?: string;
  gradient: string;
  createdAt: Date;
  updatedAt: Date;
};

export type Product = {
  id: number;
  name: string;
  description: string;
  images?: string[];
  features: string[];
  technicalSpecs: TechnicalSpec[];
  price: string;
  categoryId?: number;
  inStock: boolean;
  brand: string;
  condition: string;
  createdAt: Date;
  updatedAt: Date;
  sector?: string;
  reference?: string;
  location?: string;
  year?: number | null;
  category?: string;
  specs?: Record<string, string>;
  imageUrl?: string;
  videoUrl?: string;
};

export type AdminUser = {
  id: number;
  username: string;
  password: string;
  createdAt: Date;
};

export type ScheduleCall = {
  id: number;
  name: string;
  phone: string;
  email?: string | null;
  preferredTime?: string | null;
  scheduledFor: string | Date;
  status: 'pending' | 'completed' | 'cancelled';
  createdAt: Date;
};

export type ContactForm = {
  id: number;
  name: string;
  email: string;
  message: string;
  productId: number;
  createdAt: Date;
};

// Esquemas de validación
export const technicalSpecSchema = z.object({
  label: z.string(),
  value: z.string()
});

export type TechnicalSpec = z.infer<typeof technicalSpecSchema>;

export const insertProductSchema = z.object({
  name: z.string().min(1, { message: "El nombre es requerido" }),
  description: z.string().min(1, { message: "La descripción es requerida" }),
  price: z.string().min(1, { message: "El precio es requerido" }),
  categoryId: z.number().optional(),
  features: z.array(z.string()),
  technicalSpecs: z.array(technicalSpecSchema),
  imageUrl: z.string().optional(),
  videoUrl: z.string().optional(),
  inStock: z.boolean().default(true),
  brand: z.string().default(""),
  condition: z.string().default("new"),
  sector: z.string().optional(),
  reference: z.string().optional(),
  location: z.string().optional(),
  year: z.number().nullable().optional(),
  category: z.string().optional(),
  specs: z.record(z.string()).optional(),
});

export type InsertProduct = z.infer<typeof insertProductSchema>;

export const insertContactFormSchema = z.object({
  productId: z.number(),
  name: z.string().min(1, { message: "Name is required" }),
  email: z.string().email({ message: "Invalid email address" }),
  message: z.string().min(1, { message: "Message is required" }),
});

export type InsertContactForm = z.infer<typeof insertContactFormSchema>;

export const insertScheduleCallSchema = z.object({
  name: z.string().min(1, { message: "El nombre es requerido" }),
  phone: z.string().min(1, { message: "El teléfono es requerido" }),
  email: z.string().email("Email inválido").optional().nullable(),
  preferredTime: z.string().optional().nullable(),
});

export type InsertScheduleCall = z.infer<typeof insertScheduleCallSchema>;
